import LAW from '@/model/law'

const state = ({
  notifications: {
    count: 0,
    list: [],
    pagination: {}
  },
  notificationActive: false,
  page: 1
})

const getters = {
  getNotifications: state => state.notifications,
  getPage: state => state.page,
  getNotificationActive: state => state.notificationActive
}

const actions = {
  notifications ({ commit, getters }) {
    console.log(getters)
    return LAW.getProfile(getters.getPage).then((response) => {
      commit('setNotifications', response.data)
    })
  },

  notificationActive({ commit }, payload) {
    commit('setNotificationActive', payload)
  }
}

const mutations = {
  setNotifications(state, payload) { 

    state.notifications.count = payload.notificationsCount,

    state.notifications.list = [...state.notifications.list, ...payload.notifications]
    
    state.pagination = payload.notificationsPaginationData

    state.page++
  },

  setNotificationActive(state, payload) {
    state.notificationActive = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}